
import { IQuestionSkill as EditorQuestionSkill } from '../../types'
import OriginalQuestionSkill from '../../../api/v2/models/skill'
import OriginalQuestionSkillItem from '../../../api/v2/models/skill_item'

export default class SkillComparison {
    constructor(readonly originalQuestionSkills: OriginalQuestionSkill[] | null, readonly originalQuestionSkillItems: OriginalQuestionSkillItem[] | null, readonly editorQuestionSkills: EditorQuestionSkill | null) {}

    get isSame(){
        if (!this.editorQuestionSkills || !this.originalQuestionSkills) {
            return false
        }
        return JSON.stringify(originalQuestionSkillArray(this.originalQuestionSkills, this.originalQuestionSkillItems))==JSON.stringify(editorQuestionSkillArray(this.editorQuestionSkills))
    }
}

const originalQuestionSkillArray = (originalQuestionSkills: OriginalQuestionSkill[], originalQuestionSkillItems: OriginalQuestionSkillItem[]) => {
    const arr = []
    originalQuestionSkills.forEach(originalQuestionSkill => {
        originalQuestionSkill.skillItems.forEach(skillItem => {
            const matchedItem = originalQuestionSkillItems.find(item => item.id == skillItem.id)
            if (matchedItem) {
                let resultMatching = `${originalQuestionSkill.name}_${skillItem.name}_${matchedItem.criteria}`
                // Include answerItems for symmetric comparison with editor side
                if (matchedItem.answerItems) {
                    matchedItem.answerItems.forEach(answerItem => {
                        resultMatching += `_${answerItem.body}_${answerItem.allotment}_${answerItem.correct}`
                    })
                }
                arr.push(resultMatching)
            }
        })
    });
    arr.sort()
    return arr
}

const editorQuestionSkillArray = (editorQuestionSkills: EditorQuestionSkill) => {
    const arr = []
    Object.keys(editorQuestionSkills).forEach(name => {
        editorQuestionSkills[name].forEach(skillItem => {
            let resultMatching = `${name}_${skillItem.name}_${skillItem.criteria}`
            // Include answerItemsAttributes for symmetric comparison with original side
            const answerItemsAttributes = skillItem.answerItemsAttributes
            if (answerItemsAttributes) {
                answerItemsAttributes.forEach(answerItem => {
                    resultMatching += `_${answerItem.body}_${answerItem.allotment}_${answerItem.correct}`
                })
            }
            arr.push(resultMatching)
        });
    });
    arr.sort()
    return arr
}
